// extracted by mini-css-extract-plugin
export default {"yearsTab":"yearTabCommon_yearsTab__5PGyr","yearsTabItem":"yearTabCommon_yearsTabItem__sZSMj"};